import React, { useState } from 'react';
import { Phone, Check } from 'lucide-react';
export function Contact() {
  const [showCopied, setShowCopied] = useState(false);
  const handlePhoneClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    // Fire Google Ads conversion event
    if (typeof window !== 'undefined' && (window as any).gtag) {
      ;
      (window as any).gtag('event', 'conversion', {
        send_to: 'AW-349742034/M8ECCPrSnrADENLH4qYB'
      });
    }
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    if (!isMobile) {
      e.preventDefault();
      const phoneNumber = '(818) 381-9905';
      navigator.clipboard.writeText(phoneNumber).then(() => {
        setShowCopied(true);
        setTimeout(() => setShowCopied(false), 2000);
      }).catch(() => {
        window.location.href = 'tel:8183819905';
      });
    }
  };
  return <section className="w-full bg-gradient-to-b from-black to-zinc-950 py-20 px-4" id="contact" data-id="element-35">
      <div className="max-w-5xl mx-auto text-center" data-id="element-36">
        <h2 className="text-3xl md:text-5xl font-black uppercase text-white mb-2" data-id="element-37">
          Ready for a{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-300 to-yellow-600" data-id="element-38">
            Showroom Shine?
          </span>
        </h2>
        <p className="text-gray-400 text-lg mb-8" data-id="element-39">
          Book your mobile car detailing appointment today — serving Camarillo,
          Thousand Oaks, Simi Valley, Ventura, Agoura Hills, Calabasas Woodland
          Hills & Ventura County
        </p>

        <div className="flex flex-col items-center gap-8" data-id="element-40">
          <a href="tel:8183819905" onClick={handlePhoneClick} className="group relative flex flex-col items-center justify-center p-8 md:p-12 bg-zinc-900 border-2 border-red-600 rounded-2xl hover:bg-zinc-800 transition-all duration-300 shadow-[0_0_40px_-10px_rgba(220,38,38,0.3)] hover:shadow-[0_0_60px_-10px_rgba(220,38,38,0.5)] cursor-pointer" aria-label="Call Mike's Pro Detail" data-id="element-41">
            <span className="text-xl md:text-2xl text-gray-400 uppercase tracking-widest mb-2 font-bold" data-id="element-42">
              Call or Text Mike
            </span>
            <div className="flex items-center gap-3 md:gap-6" data-id="element-43">
              <Phone className="w-8 h-8 md:w-12 md:h-12 text-red-500 fill-red-500/20" data-id="element-44" />
              <span className="text-4xl md:text-6xl lg:text-7xl font-black text-white tracking-tighter group-hover:scale-105 transition-transform" data-id="element-45">
                (818) 381-9905
              </span>
            </div>
            <div className="absolute -bottom-4 bg-black px-4 py-1 border border-zinc-800 rounded-full" data-id="element-46">
              <span className="text-green-500 font-bold uppercase text-sm flex items-center gap-2" data-id="element-47">
                <span className="relative flex h-3 w-3" data-id="element-48">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75" data-id="element-49"></span>
                  <span className="relative inline-flex rounded-full h-3 w-3 bg-green-500" data-id="element-50"></span>
                </span>
                Available Now
              </span>
            </div>
          </a>

          {/* Copied to clipboard toast */}
          {showCopied && <div className="fixed top-8 left-1/2 -translate-x-1/2 z-50 flex items-center gap-2 px-4 py-3 bg-green-600 text-white rounded-lg shadow-lg animate-in fade-in slide-in-from-top-2 duration-300" data-id="element-51">
              <Check className="w-5 h-5" data-id="element-52" />
              <span className="font-semibold" data-id="element-53">
                Phone number copied to clipboard!
              </span>
            </div>}

          {/* Footer navigation: internal + external links */}
          <nav aria-label="Footer navigation" className="mt-12 pt-8 border-t border-zinc-900 w-full text-gray-500 text-sm" data-id="element-54">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 text-left mb-8" data-id="element-55">
              {/* Services */}
              <div data-id="element-56">
                <h3 className="text-white font-bold uppercase tracking-wider text-xs mb-3" data-id="element-57">
                  Detailing Services
                </h3>
                <ul className="space-y-2" data-id="element-58">
                  <li data-id="element-59">
                    <a href="/services/mobile-detailing" className="hover:text-yellow-400 transition-colors" data-id="element-60">
                      Mobile Detailing
                    </a>
                  </li>
                  <li data-id="element-61">
                    <a href="/services/interior-detailing" className="hover:text-yellow-400 transition-colors" data-id="element-62">
                      Interior Detailing
                    </a>
                  </li>
                  <li data-id="element-63">
                    <a href="/services/exterior-detailing" className="hover:text-yellow-400 transition-colors" data-id="element-64">
                      Exterior Detailing
                    </a>
                  </li>
                  <li data-id="element-65">
                    <a href="/services/full-car-detail" className="hover:text-yellow-400 transition-colors" data-id="element-66">
                      Full Car Detail
                    </a>
                  </li>
                </ul>
              </div>

              {/* Service areas */}
              <div data-id="element-67">
                <h3 className="text-white font-bold uppercase tracking-wider text-xs mb-3" data-id="element-68">
                  Service Areas
                </h3>
                <ul className="space-y-2" data-id="element-69">
                  <li data-id="element-70">
                    <a href="/ventura-county/camarillo" className="hover:text-yellow-400 transition-colors" data-id="element-71">
                      Camarillo
                    </a>
                  </li>
                  <li data-id="element-72">
                    <a href="/ventura-county/oxnard" className="hover:text-yellow-400 transition-colors" data-id="element-73">
                      Oxnard
                    </a>
                  </li>
                  <li data-id="element-74">
                    <a href="/ventura-county/ventura" className="hover:text-yellow-400 transition-colors" data-id="element-75">
                      Ventura
                    </a>
                  </li>
                  <li data-id="element-76">
                    <a href="/ventura-county/thousand-oaks" className="hover:text-yellow-400 transition-colors" data-id="element-77">
                      Thousand Oaks
                    </a>
                  </li>
                </ul>
              </div>

              {/* Find us online (external links) */}
              <div data-id="element-78">
                <h3 className="text-white font-bold uppercase tracking-wider text-xs mb-3" data-id="element-79">
                  Find Us Online
                </h3>
                <ul className="space-y-2" data-id="element-80">
                  <li data-id="element-81">
                    <a href="https://www.google.com/maps/search/Mike%27s+Pro+Detail+Ventura+County" target="_blank" rel="noopener noreferrer" className="hover:text-yellow-400 transition-colors" data-id="element-82">
                      Google Maps &amp; Reviews
                    </a>
                  </li>
                  <li data-id="element-83">
                    
                  </li>
                  <li data-id="element-84">
                    <a href="https://www.bbb.org/search?find_text=Mike%27s+Pro+Detail&find_loc=Ventura+County%2C+CA" target="_blank" rel="noopener noreferrer" className="hover:text-yellow-400 transition-colors" data-id="element-85"></a>
                  </li>
                </ul>
              </div>
            </div>

            <div className="pt-6 border-t border-zinc-900 flex flex-col md:flex-row justify-between items-center gap-2 text-gray-600" data-id="element-86">
              <p data-id="element-87">
                © {new Date().getFullYear()} Mike's Pro Detail — Mobile Car
                Detailing Ventura County &amp; San Fernando Valley. All rights
                reserved.
              </p>
              <p data-id="element-88">
                <a href="/#services" className="hover:text-gray-400 transition-colors" data-id="element-89">
                  Services
                </a>
                {' · '}
                <a href="/#service-areas" className="hover:text-gray-400 transition-colors" data-id="element-90">
                  Service Areas
                </a>
                {' · '}
                <a href="/#faq" className="hover:text-gray-400 transition-colors" data-id="element-91">
                  FAQ
                </a>
              </p>
            </div>
          </nav>
        </div>
      </div>
    </section>;
}